import { changeRoute, resetRoute } from '../actions/publicActions';
import { DEEPLINK_DEFINITIONS } from '../routes/bootstrapDeepLinkDefinitions';
import { navigateToRoute, setForceRouteHandler } from 'owa-router';
import { initializeWindowTitle } from 'owa-shared-bootstrap';
import { orchestrator } from 'satcheljs';

const DelayAfterRenderInMilliseconds = 100;

orchestrator(changeRoute, actionMessage => {
    resetRoute();

    const deeplinkDefinition = DEEPLINK_DEFINITIONS[actionMessage.view];

    initializeWindowTitle(deeplinkDefinition.getModuleName);

    setForceRouteHandler(true);
    navigateToRoute(deeplinkDefinition.getRouteSegments());

    deeplinkDefinition.postLazyAction.import();

    setTimeout(() => {
        deeplinkDefinition.postLazyAction.importAndExecute();
    }, DelayAfterRenderInMilliseconds);
});
